if (!customElements.get('price-slider')) {
  class PriceSlider extends HTMLElement {
    constructor() {
      super();
      this.firstRun = true;
      this.updateTimeout = null;
      this.previousMinValue = null;
      this.previousMaxValue = null;
      this.isUpdating = false;
      this.init();
    }

    init() {
      this.priceSlider = this.querySelector('#price-slider');
      this.priceRangeComponent = this.parentElement?.querySelector('price-range');
      this.filterMaxText = this.querySelector('[filter-max-text]');
      this.filterMinText = this.querySelector('[filter-min-text]');
      this.filterMinContainer = this.parentElement?.querySelector('.belo--filter-range__min');
      this.filterMaxContainer = this.parentElement?.querySelector('.belo--filter-range__max');
      
      // Get references to the new price display elements
      this.priceMinDisplay = this.priceRangeComponent?.querySelector('[data-min-display]');
      this.priceMaxDisplay = this.priceRangeComponent?.querySelector('[data-max-display]');
      
      // Also get references to the hidden inputs for the new display
      this.minInputDisplay = this.priceRangeComponent?.querySelector('[data-min-input]');
      this.maxInputDisplay = this.priceRangeComponent?.querySelector('[data-max-input]');
      
      // Store the range max value from data attribute
      if (this.dataset.rangeMax) {
        this.storedRangeMax = Number(this.dataset.rangeMax);
      }
      
      // if (this.filterMinContainer.hasAttribute('value')) {
      //   this.filterMinContainer.nextElementSibling.classList.add('visibility');
      // }

      // if (this.filterMaxContainer.hasAttribute('value')) {
      //  this.filterMaxContainer.nextElementSibling.classList.add('visibility');
      // }

      if (!this.priceRangeComponent) {
        console.error("Price range component not found");
        return;
      }
      this.minInput = this.priceRangeComponent.querySelector('[name="filter.v.price.gte"]');
      this.maxInput = this.priceRangeComponent.querySelector('[name="filter.v.price.lte"]');

      if (!this.minInput || !this.maxInput) {
        console.error("Min or Max input elements not found");
        return;
      }

      this.previousMinValue = this.minInput.value;
      this.previousMaxValue = this.maxInput.value;

      this.initSlider();
    }

    initSlider() {
      if (this.priceSlider.noUiSlider) {
        this.priceSlider.noUiSlider.destroy();
      }

      const currentMinValue = Number(this.minInput.value) || 0;
      const currentMaxValue = Number(this.maxInput.value) || this.storedRangeMax || Number(this.dataset.rangeMax) || 1000;
      this.minValue = Number(this.minInput.dataset.min) || 0;
      this.maxValue = this.storedRangeMax || Number(this.dataset.rangeMax) || Number(this.maxInput.dataset.max) || 1000;

      noUiSlider.create(this.priceSlider, {
        start: [currentMinValue, currentMaxValue],
        connect: true,
        range: {
          'min': this.minValue,
          'max': this.maxValue,
        },
        step: 1,
        tooltips: false,
      });

      this.priceSlider.noUiSlider.on('update', (values) => {
        if (this.firstRun) {
          this.firstRun = false;
        }

        this.updateDisplayedPrices(values);
      });

      this.priceSlider.noUiSlider.on('change', (values) => {
        this.handleSliderChange(values);
      });
    }

    updateDisplayedPrices(values) {
      if (this.filterMaxText && this.filterMinText) {
        this.filterMinText.textContent = window.accessibilityStrings.currenySymbol + values[0];
        this.filterMaxText.textContent = window.accessibilityStrings.currenySymbol + values[1];
      }

      if (this.priceMinDisplay && this.priceMaxDisplay) {
        const currencySymbol = window.accessibilityStrings?.currenySymbol || '$';
        this.priceMinDisplay.textContent = currencySymbol + parseFloat(values[0]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        this.priceMaxDisplay.textContent = currencySymbol + parseFloat(values[1]).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    handleSliderChange(values) {
      if (this.isUpdating) {
        return;
      }

      const formattedMinInput = parseFloat(this.minInput.value.replace(/,/g, '')) || this.minValue;
      const formattedMaxInput = parseFloat(this.maxInput.value.replace(/,/g, '')) || this.maxValue;
      const formattedValuesMin = parseFloat(values[0].replace(/,/g, ''));
      const formattedValuesMax = parseFloat(values[1].replace(/,/g, ''));

      if (formattedMinInput === formattedValuesMin && formattedMaxInput === formattedValuesMax) {
        return;
      }

      const newMinValue = values[0];
      const newMaxValue = values[1];
      this.minInput.value = newMinValue;
      this.maxInput.value = newMaxValue;

      if (this.minInputDisplay) {
        this.minInputDisplay.value = newMinValue;
      }
      if (this.maxInputDisplay) {
        this.maxInputDisplay.value = newMaxValue;
      }

      const form = this.minInput.closest('form');
      const formData = new FormData(form);
      this.FiltersPram = new URLSearchParams(formData).toString();
      this.isUpdating = true;
      this.toggleLoading();
      this.updateUrl();
    }

    toggleLoading() {
      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const loadingSpinners = document.querySelectorAll(
        '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
      if (countContainer) { countContainer.classList.add('loading'); }
      if (countContainerDesktop) { countContainerDesktop.classList.add('loading'); }
      // 
      const drawerEl = document.querySelector('.mobile-facets__disclosure');
      if (drawerEl && drawerEl.classList.contains('menu-opening')) {
        drawerEl.classList.remove('menu-opening');
        if (document.body.classList.contains('overflow-hidden-mobile')) {
          document.body.classList.remove('overflow-hidden-mobile');
        }
        setTimeout(() => {
          drawerEl.removeAttribute('open');
        }, 1000);
      }
    }

    updateUrl() {
      const currentPath = window.location.pathname;
      const updatedUrl = this.FiltersPram ? `${currentPath}?${this.FiltersPram}` : currentPath;
      window.history.replaceState({}, '', updatedUrl);
      this.fetchProducts();
    }
    async fetchProducts() {
      const apiUrl = `${this.dataset.url}&${this.FiltersPram}`;
      try {
        const response = await fetch(apiUrl);
        const text = await response.json();
        const firstKey = Object.keys(text)[0];
        const htmlString = text[firstKey];
        const parser = new DOMParser();
        const textDoc = parser.parseFromString(htmlString, 'text/html');

        this.sectionIdSectionSource = textDoc?.querySelector(`#shopify-section-${this.dataset.section}`);
        this.sectionIdSection = document.querySelector(`#shopify-section-${this.dataset.section}`);
        setTimeout(() => {
          this.sectionIdSection.outerHTML = this.sectionIdSectionSource.outerHTML;
          // Reset the updating flag after the section is replaced
          this.isUpdating = false;
        }, 100);
      }
      catch (error) {
        console.error('Error fetching products:', error);
        this.isUpdating = false;
        alert('There was an error fetching products. Please try again.');
        location.reload();
      }
    }
  }
  customElements.define('price-slider', PriceSlider);
}
